// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"51e96f54","882":"1ea81620"}[chunkId] + ".chunk.css";
};